export const FETCH_REVIEWS = 'FETCH_REVIEWS';
export const FETCH_REVIEWS_SUCCESS = 'FETCH_REVIEWS_SUCCESS';
export const FETCH_REVIEWS_FAILS = 'FETCH_REVIEWS_FAILS';

export const UPDATE_USER_REVIEW_STATUS = 'UPDATE_USER_REVIEW_STATUS';
export const UPDATE_USER_REVIEW_STATUS_SUCCESS = 'UPDATE_USER_REVIEW_STATUS_SUCCESS';
export const UPDATE_USER_REVIEW_STATUS_FAILS = 'UPDATE_USER_REVIEW_STATUS_FAILS';
